import { useAppSelector } from "./store";

import PlayerIcon from "./PlayerIcon";
import "./PlayerList.css";

function PlayerList() {
  const players = useAppSelector((state) => {
    return state.players;
  });

  const profile = useAppSelector((state) => {
    return state.profile;
  });

  const renderedPlayers = players.map((player) => {
    return <PlayerIcon player={player} key={player.id} profile={profile} />;
  });

  return (
    <div className="playerList">
      <div className="players">{renderedPlayers}</div>
    </div>
  );
}

export default PlayerList;
